export const API_URL = 'https://forkify-api.herokuapp.com/api/v2/recipes/';
export const TIMEOUT_SEC = 10;
export const RES_PER_PAGE = 10;
export const KEY = 'e9fd4a48-f404-427b-8431-5ac4615fa3bb';
export const MODAL_CLOSE_SEC = 2.5;
